import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import io from "socket.io-client";
import { Input, Button, Modal, Upload ,message} from "antd";
import { SendOutlined, UploadOutlined } from "@ant-design/icons";
import { IoCheckmarkDone  } from "react-icons/io5";
import { IoCheckmark } from "react-icons/io5";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const socket = io("https://app.practicalinfoseclabs.com", {
  transports: ["websocket"],
  auth: {
    token: localStorage.getItem("token"),
  },
});

// const socket = io(`${process.env.REACT_APP_API_SOCKET}`, {
//   // path: "/socket.io",
//   transports: ["websocket"],
//   auth: {
//     token: localStorage.getItem("token"),
//   },
// });

const ChatsStudent = () => {

   useEffect(() => {
      const navEntry = performance.getEntriesByType("navigation")[0];
      const isReload = navEntry?.type === "reload";
      const hasTriggered = sessionStorage.getItem("chatsReloaded");
  
      if (!isReload && !hasTriggered) {
        sessionStorage.setItem("chatsReloaded", "true");
        window.location.reload();
        return;
      }
  
      if (isReload) {
        sessionStorage.removeItem("chatsReloaded");
      }
    }, []);
  
  const token = localStorage.getItem("token");

  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [messages, setMessages] = useState([]);

  const [input, setInput] = useState("");
  const [file, setFile] = useState(null);

  const [createModal, setCreateModal] = useState(false);
  const [groupName, setGroupName] = useState("");

  const [userModal, setUserModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [search, setSearch] = useState("");

  const [groupMembers, setGroupMembers] = useState([]);
  const [onlineUsers, setOnlineUsers] = useState([]);
const [typingUsers, setTypingUsers] = useState([]);

const [unreadGroups, setUnreadGroups] = useState({});

const selectedGroupRef = useRef(null);

  const messagesEndRef = useRef();

  const [replyTo, setReplyTo] = useState(null);

  const [activeReactionMsg, setActiveReactionMsg] = useState(null);

  

  useEffect(() => {
  selectedGroupRef.current = selectedGroup;
}, [selectedGroup]);

  /* ================= FETCH GROUPS ================= */
  const fetchGroups = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/chat/my-groups`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) setGroups(res.data.data);
  };

  /* ================= FETCH USERS ================= */
  const fetchUsers = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/chat/all-users`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) setUsers(res.data.data);
  };

  /* ================= FETCH MEMBERS ================= */
  const fetchGroupMembers = async (groupId) => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/chat/group-members/${groupId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) setGroupMembers(res.data.data);
  };

  /* ================= FETCH MESSAGES ================= */
const fetchMessages = async (groupId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/chat/messages/${groupId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // console.log("MESSAGES API RESPONSE:", res.data);

    if (res.data.success) {
      setMessages(res.data.data || []);
      setInput("");
      scrollToBottom();
    } else {
      setMessages([]);
    }
  } catch (err) {
    console.error("fetchMessages error:", err?.response?.data || err.message);
    setMessages([]);
  }
};
  /* ================= SELECT GROUP ================= */
 const handleSelectGroup = (group) => {
  setSelectedGroup(group);
  fetchMessages(group.id);
  fetchGroupMembers(group.id);
  socket.emit("join_group", group.id);
  socket.emit("message_seen", group.id);
  fetchUnreadCounts();

  // ✅ remove unread dot
  setUnreadGroups((prev) => {
    const updated = { ...prev };
   delete updated[String(group.id)];
    return updated;
  });

  
};

  /* ================= SEND MESSAGE ================= */
const handleSend = async () => {
  if (!input && !file) return;

  let fileKey = null;

  if (file) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("groupId", selectedGroup.id);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/chat/upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (res.data.success) {
      fileKey = res.data.fileKey;
    }
  }

  socket.emit("send_message", {
    groupId: selectedGroup.id,
    message: input,
    messageType: fileKey ? "FILE" : "TEXT",
    fileUrl: fileKey,
    replyTo: replyTo?.id || null
  });

  scrollToBottom();

  setInput("");
  setFile(null);
  setReplyTo(null); // ✅ FIX IMPORTANT
};

  /* ================= ADD MULTIPLE USERS ================= */
  const handleAddUsers = async () => {
    for (let userId of selectedUsers) {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/chat/add-member`,
        { groupId: selectedGroup.id, userId, role: "MEMBER" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    }


    setUserModal(false);
     setSelectedUsers([]);
    fetchGroupMembers(selectedGroup.id);
   
  };



  /* ================= REMOVE USER ================= */
  const handleRemoveUser = async (userId) => {
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/chat/remove-member`,
      {
        data: { groupId: selectedGroup.id, userId },
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    fetchGroupMembers(selectedGroup.id);
  };

  /* ================= SOCKET ================= */
 useEffect(() => {

  socket.on("receive_message", (msg) => {
  const currentGroupId = selectedGroupRef.current?.id;
  const userId = Number(localStorage.getItem("userId"));

  const isMe = msg.SenderId === userId;

  if (currentGroupId && String(msg.GroupId) === String(currentGroupId)) {
    // ✅ always show message (even your own)
    setMessages((prev) => [...prev, msg]);
     socket.emit("message_seen", msg.GroupId);
    scrollToBottom();
  } else {
    // ❗ only mark unread for OTHER users
    if (!isMe) {
      setUnreadGroups((prev) => ({
  ...prev,
  [msg.GroupId]: (prev[msg.GroupId] || 0) + 1,
}));
    }
  }
});

  return () => {
    socket.off("receive_message");
  };
}, []);

useEffect(() => {
  if (selectedGroup) {
    socket.emit("message_seen", selectedGroup.id);
  }
}, [selectedGroup]);

useEffect(() => {
  if (messages.length > 0 && selectedGroup) {
    socket.emit("message_seen", selectedGroup.id);
  }
}, [messages]);



useEffect(() => {
  if (!socket) return;

  /* ===========================
     ❤️ REACTION UPDATE
  =========================== */
  const handleReactionUpdate = ({ messageId, reaction, userId }) => {
  setMessages((prev) =>
    prev.map((msg) => {
      if (msg.id !== messageId) return msg;

      const existing = msg.reactions || [];

      const alreadyReacted = existing.find(
        (r) => r.reaction === reaction && r.userId === userId
      );

      let updated;

      if (alreadyReacted) {
        // ❌ REMOVE (toggle)
        updated = existing.filter(
          (r) => !(r.reaction === reaction && r.userId === userId)
        );
      } else {
        // ✅ ADD
        updated = [...existing, { reaction, userId }];
      }

      return { ...msg, reactions: updated };
    })
  );
};



  /* ===========================
     SOCKET LISTENERS
  =========================== */
  socket.on("reaction_update", handleReactionUpdate);

  /* ===========================
     CLEANUP (VERY IMPORTANT)
  =========================== */
  return () => {
    socket.off("reaction_update", handleReactionUpdate);
  };

}, []);

useEffect(() => {
  if (!socket) return;

  const handleMessagePinned = ({ messageId, IsPinned }) => {
    // console.log("PIN RECEIVED:", messageId, IsPinned); // ✅ debug

    setMessages((prev) =>
      prev.map((msg) =>
        msg.id === messageId
          ? { ...msg, IsPinned }
          : msg
      )
    );
  };

  socket.on("message_pinned", handleMessagePinned);

  return () => {
    socket.off("message_pinned", handleMessagePinned);
  };
}, []);

  /* ================= CREATE GROUP ================= */
  const handleCreateGroup = async () => {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/chat/create-group`,
      { groupName, groupType: "GENERAL" },
      { headers: { Authorization: `Bearer ${token}` } }
    );
 
    if (res.data.success) {
      setCreateModal(false);
      setGroupName("");
      fetchGroups();
    }
  };


  const fetchUnreadCounts = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/chat/unread-counts`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      const map = {};

      res.data.data.forEach((item) => {
        map[item.GroupId] = Number(item.unread);
      });

      setUnreadGroups(map); 
    }
  } catch (err) {
    console.error("Unread fetch error", err);
  }
};

useEffect(() => {
  fetchUnreadCounts();
  
}, []);



useEffect(() => {
  if (selectedGroup) {
    socket.emit("message_seen", selectedGroup.id);

    fetchUnreadCounts(); // 🔥 sync

    const totalUnread = Object.values(unreadGroups || {}).reduce(
  (sum, count) => sum + count,
  0
);

    localStorage.setItem("chatUnreadCount", totalUnread);
    window.dispatchEvent(new Event("chatUnreadUpdated"));

  }
}, [selectedGroup]);



useEffect(() => {

  socket.on("new_message_notification", (data) => {
  // console.log("NOTIFICATION EVENT:", data);
 

  const currentGroupId = selectedGroupRef.current?.id;

  if (String(currentGroupId) !== String(data.groupId)) {

    if (Notification.permission === "granted") {

      setTimeout(() => {
        const notification = new Notification("💬 New Message", {
          body: `${data.sender}\n${data.message}`,
          tag: `group-${data.groupId}`,
          renotify: true,
          requireInteraction: true,
        });

        notification.onclick = () => {
          window.focus();
        };
      }, 500); // 🔥 delay helps browser trigger

    }
  }
});

  socket.on("mention_notification", (data) => {
    message.info("🔔 You were mentioned!");
  });

  return () => {
    socket.off("new_message_notification");
    socket.off("mention_notification");
  };

}, []);


  /* ================= SEARCH FILTER ================= */
 const filteredUsers = users.filter((u) =>
  u.FullName?.toLowerCase().includes(search.toLowerCase()) ||
  u.Email?.toLowerCase().includes(search.toLowerCase())
);

  /* ================= SCROLL ================= */
  const scrollToBottom = () => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  useEffect( () =>  {
  if ("Notification" in window && Notification.permission !== "granted") {
    Notification.requestPermission();
  }
}, []);

const typingTimeoutRef = useRef(null);

const handleTyping = () => {
  if (!selectedGroup) return;

  socket.emit("typing", selectedGroup.id);

  if (typingTimeoutRef.current) {
    clearTimeout(typingTimeoutRef.current);
  }

  typingTimeoutRef.current = setTimeout(() => {
    socket.emit("stop_typing", selectedGroup.id);
  }, 1500);
};
  
useEffect(() => {

  socket.on("typing", (user) => {
    setTypingUsers((prev) => {
      // ✅ prevent duplicates
      const exists = prev.find((u) => u.id === user.id);
      if (exists) return prev;

      return [...prev, user];
    });
  });

  socket.on("stop_typing", (user) => {
    setTypingUsers((prev) =>
      prev.filter((u) => u.id !== user.id)
    );
  });

  return () => {
    socket.off("typing");
    socket.off("stop_typing");
  };

}, []);

useEffect(() => {
  socket.on("online_users", (users) => {
    // console.log("ONLINE USERS:", users); // debug
    setOnlineUsers(users);
  });

  return () => {
    socket.off("online_users");
  };
}, []);

useEffect(() => {
  const handleMessagesSeen = ({ groupId }) => {
    setMessages((prev) =>
      prev.map((msg) =>
        String(msg.GroupId) === String(groupId)
          ? { ...msg, Seen: true }
          : msg
      )
    );
  };

  socket.on("messages_seen", handleMessagesSeen);

  return () => socket.off("messages_seen", handleMessagesSeen);
}, []);

  return (
    <div className="flex h-[90vh]">

    <div className="flex flex-col w-1/4 border-r bg-gradient-to-b from-white to-slate-50">

  {/* 🔍 HEADER */}
  <div className="flex items-center justify-between px-4 py-3 bg-white border-b shadow-sm">

    <h2 className="text-base font-semibold text-gray-800">
      Chats
    </h2>

    <div className="flex items-center gap-2">

  {/* <Button
    onClick={() => setCreateModal(true)}
    className="flex items-center gap-2 px-3 text-sm font-medium text-white border-none rounded-lg h-9 bg-gradient-to-r from-blue-500 to-indigo-600 hover:opacity-90"
  >
    ➕ Create Group
  </Button> */}



</div>
  </div>

  {/* 🔎 SEARCH */}
  <div className="p-3 bg-white border-b">
    <Input
      placeholder="Search chats..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="text-sm bg-gray-100 border-none rounded-full focus:bg-white"
    />
  </div>



  {/* 💬 GROUP LIST */}
  <div className="flex-1 overflow-y-auto">

    {groups
      .filter((g) =>
        g.GroupName?.toLowerCase().includes(search?.toLowerCase())
      )
      .map((g) => {

        const isActive = selectedGroup?.id === g.id;

        return (
          <div
            key={g.id}
            onClick={() => handleSelectGroup(g)}
            className={`flex items-center gap-3 px-4 py-3 cursor-pointer transition-all
              ${isActive
                ? "bg-blue-50 border-r-4 border-blue-500"
                : "hover:bg-gray-100"
              }
            `}
          >

            {/* 👤 AVATAR */}
            <div className="relative">
              <div className="flex items-center justify-center w-10 h-10 font-semibold text-white rounded-full bg-gradient-to-br from-blue-500 to-indigo-600">
                {g.GroupName?.charAt(0).toUpperCase()}
              </div>

              {/* Optional online dot (if needed later) */}
            </div>

            {/* 📄 TEXT */}
            <div className="flex-1 overflow-hidden">

              <div className="text-sm font-semibold text-gray-800 truncate">
                {g.GroupName}
              </div>

              {/* Optional subtitle */}
              <div className="text-xs text-gray-400 truncate">
                Tap to open chat
              </div>

            </div>

            {/* 🟢 UNREAD */}
            {unreadGroups[g.id] && (
              <span className="px-2 py-[2px] text-[10px] font-semibold text-white bg-green-500 rounded-full shadow">
                {unreadGroups[g.id]}
              </span>
            )}

          </div>
        );
      })}

  </div>
</div>



 {/* ================= MAIN ================= */}
      {messages.length > 0 && (
  <div className="flex flex-col flex-1">

      {/* HEADER */}
<div className="flex items-center justify-between p-4 bg-white border-b shadow-sm">

  {/* LEFT: Group Info */}
  <div className="flex items-center gap-3">

    {/* Avatar */}
    <div className="flex items-center justify-center w-10 h-10 font-semibold text-white rounded-full bg-gradient-to-br from-indigo-500 to-blue-600">
      {selectedGroup?.GroupName?.charAt(0)?.toUpperCase()}
    </div>

    {/* Name + Sub */}
    <div>
      <h2 className="text-sm font-semibold text-gray-800">
        {selectedGroup?.GroupName}
      </h2>
      <p className="text-xs text-gray-500">
        Group Chat
      </p>
    </div>

    

  </div>

  {/* RIGHT: Actions */}
  <div className="flex items-center gap-3">

    {/* Example icons (optional actions) */}
   {/* <Button
    onClick={() => {
      setUserModal(true);
      fetchUsers();
    }}
    className="flex items-center gap-2 px-3 text-sm font-medium text-white bg-blue-700 border-none rounded-lg h-9 hover:bg-blue-900"
  >
    + Add User
  </Button> */}

  </div> 
</div>

        {/* MEMBERS */}
<div className="flex flex-wrap gap-2 p-2 bg-gray-400 border-b">

  {groupMembers.map((m) => (
    <div
      key={m.id}
      className="flex items-center gap-1.5 px-2 py-1 bg-gray-50 border rounded-full hover:bg-gray-100 transition"
    >

      {/* Avatar */}
      <div className="relative">
       <div className="w-5 h-5">
  {m.ProfilePhotoUrl ? (
    <img
      src={m.ProfilePhotoUrl}
      alt={m.FullName}
      className="object-cover w-5 h-5 rounded-full"
    />
  ) : (
    <div className="flex items-center justify-center w-5 h-5 text-[9px] font-semibold text-white rounded-full bg-gradient-to-br from-indigo-500 to-blue-600">
      {m.FullName?.charAt(0)?.toUpperCase()}
    </div>
  )}
</div>

        {/* Online Indicator */}
        {onlineUsers.includes(m.id) && (
          <span className="absolute bottom-0 right-0 w-2 h-2 bg-green-500 border border-white rounded-full"></span>
        )}
      </div>

      {/* Name */}
      <span className="text-xs font-medium text-gray-700">
        {m.FullName}
      </span>

      {/* Remove */}
      {/* <button
        onClick={() => handleRemoveUser(m.id)}
        className="text-[10px] text-gray-400 hover:text-red-500 transition"
      >
        ✕
      </button> */}
    </div>
  ))}

</div>

{/* 📌 PINNED MESSAGES */}
{messages.some((m) => m.IsPinned) && (
  <div className="px-3 py-2 border-b bg-amber-200 backdrop-blur-sm">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-1">

      <div className="text-[11px] font-semibold tracking-wide text-black uppercase">
        📌 Pinned Messages
      </div>

    </div>

    {/* LIST */}
    <div className="space-y-1">

      {messages
        .filter((m) => m.IsPinned)
        .map((m) => (
          <div
            key={m.id}
            className="flex items-center justify-between px-2 py-1 transition bg-white border rounded-md group hover:bg-yellow-50"
          >

            {/* MESSAGE TEXT */}
            <div className="text-[12px] text-gray-700 truncate max-w-[80%]">
              {m.Message}
            </div>

            {/* ❌ UNPIN BUTTON */}
            {/* <button
              onClick={() =>
                socket.emit("pin_message", {
                  messageId: m.id,
                  groupId: selectedGroup.id,
                })
              }
              className="text-[10px] text-gray-400 opacity-0 group-hover:opacity-100 hover:text-red-500 transition"
            >
              ✕
            </button> */}

          </div>
        ))}

    </div>

  </div>
)}

      {/* ================= MESSAGES ================= */}
<div className="flex-1 p-6 overflow-y-auto bg-gradient-to-br from-slate-300 via-red-50 to-slate-300">

  {messages.map((msg, index) => {
    const isMe = msg.SenderId === Number(localStorage.getItem("userId"));

    const prevMsg = messages[index - 1];
    const nextMsg = messages[index + 1];

    const isSameSender =
      prevMsg && prevMsg.SenderId === msg.SenderId;

    const isNewSenderBlock =
      index === 0 || prevMsg?.SenderId !== msg.SenderId;

    const isLastMessageOfGroup =
      !nextMsg || nextMsg.SenderId !== msg.SenderId;

    const currentDate = dayjs(msg.CreatedAt).format("YYYY-MM-DD");

    const prevDate =
      index > 0
        ? dayjs(messages[index - 1].CreatedAt).format("YYYY-MM-DD")
        : null;

    const showDate = currentDate !== prevDate;

    const time = dayjs.utc(msg.CreatedAt).local().format("hh:mm A");
    

    const messageDay = dayjs(msg.CreatedAt);

    const currentDateLabel = messageDay.isSame(dayjs(), "day")
      ? "Today"
      : messageDay.isSame(dayjs().subtract(1, "day"), "day")
      ? "Yesterday"
      : messageDay.format("DD MMM YYYY");

    const initials = msg.SenderName
      ? msg.SenderName.split(" ").map((n) => n[0]).join("").toUpperCase()
      : "U";

    const isImage = msg.FileUrl?.match(/\.(jpg|jpeg|png|webp)$/i);

    return (
  <div key={msg.id} id={`msg-${msg.id}`}>
    {/* 📅 DATE */}
    {showDate && (
      <div className="flex justify-center my-6">
        <span className="px-4 py-1 text-xs font-medium text-gray-600 bg-white rounded-full shadow">
          {currentDateLabel}
        </span>
      </div>
    )}

    {/* 💬 MESSAGE */}
    <div
      className={`flex ${
        isMe ? "justify-end" : "justify-start"
      } ${isNewSenderBlock ? "mt-4" : "mt-1"}`}
    >
      {/* LEFT (OTHERS) */}
      {!isMe && (
        <div className="flex max-w-xl gap-3">
          {/* AVATAR */}
          {!isSameSender ? (
            <div className="relative w-10 h-10">
              {msg.SenderProfilePhoto ? (
                <img
                  src={msg.SenderProfilePhoto}
                  className="object-cover w-10 h-10 rounded-full shadow"
                />
              ) : (
                <div className="flex items-center justify-center w-10 h-10 font-semibold text-white rounded-full shadow bg-gradient-to-br from-pink-400 to-purple-500">
                  {initials}
                </div>
              )}

              {onlineUsers.includes(msg.SenderId) && (
                <span className="absolute top-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></span>
              )}
            </div>
          ) : (
            <div className="w-10" />
          )}

          {/* MESSAGE BLOCK */}
          <div>
            {/* NAME */}
            {!isSameSender && (
              <div className="mb-1 text-xs font-semibold text-gray-800">
                {msg.SenderName}
              </div>
            )}

            {/* BUBBLE */}
            <div className="relative inline-block px-3 pb-2 text-white rounded-lg shadow-md pt-7 bg-gradient-to-r from-green-200 to-green-200 group">
              {/* MESSAGE ACTIONS */}
              <div className="absolute z-10 flex gap-2 transition opacity-0 top-1 left-2 group-hover:opacity-100">
                <button
                  onClick={() => setActiveReactionMsg(msg.id)}
                  className="px-1 text-xs bg-white rounded shadow hover:scale-110"
                >
                  😊
                </button>

                {/* <button
                  onClick={() =>
                    socket.emit("pin_message", {
                      messageId: msg.id,
                      groupId: selectedGroup.id,
                    })
                  }
                  className="px-1 text-xs bg-white rounded shadow hover:scale-110"
                >
                  📌
                </button> */}
              </div>

              {/* PIN LABEL */}
              {msg.IsPinned && (
                <div className="mb-1 text-[10px] font-semibold text-yellow-700">
                  📌 Pinned
                </div>
              )}

              {/* REPLY */}
              {msg.ReplyMessage && (
                <div className="p-2 mb-1 text-xs bg-gray-800 rounded">
                  <span className="font-semibold text-green-500">
                    {msg.ReplySenderName}
                  </span>{" "}
                  : {msg.ReplyMessage}
                </div>
              )}

              {/* MESSAGE */}
              {msg.Message && (
                <p
                  className="font-medium text-black text-md"
                  dangerouslySetInnerHTML={{
                    __html: msg.Message.replace(
                      /@(\w+)/g,
                      "<span class='text-blue-600 font-semibold'>@$1</span>"
                    ),
                  }}
                />
              )}

              {/* REACTION PICKER */}
              {activeReactionMsg === msg.id && (
                <div className="flex gap-1 p-1 mt-2 bg-white border rounded shadow">
                  {["❤️", "👍", "🔥", "😂", "😮"].map((emoji) => (
                    <span
                      key={emoji}
                      className="cursor-pointer hover:scale-125"
                      onClick={() => {
                        socket.emit("add_reaction", {
                          messageId: msg.id,
                          reaction: emoji,
                          groupId: selectedGroup.id,
                        });
                        setActiveReactionMsg(null);
                      }}
                    >
                      {emoji}
                    </span>
                  ))}
                </div>
              )}

              {/* FILE */}
              {msg.FileUrl && (
                <div className="mt-2">
                  <img
                    src={msg.FileUrl}
                    className="max-w-xs shadow rounded-xl"
                    onError={(e) => {
                      e.target.style.display = "none";
                      const videoEl = e.target.nextSibling;
                      if (videoEl) videoEl.style.display = "block";
                    }}
                  />

                  <video
                    src={msg.FileUrl}
                    controls
                    className="hidden max-w-xs shadow rounded-xl"
                    onError={(e) => {
                      e.target.style.display = "none";
                      const fileEl = e.target.nextSibling;
                      if (fileEl) fileEl.style.display = "block";
                    }}
                  />

                  <a
                    href={msg.FileUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="hidden mt-4 text-sm font-medium text-black underline"
                  >
                    📎 View File
                  </a>
                </div>
              )}

              {/* REPLY BUTTON */}
              <button
                onClick={() => setReplyTo(msg)}
                className="mt-1 text-[10px] text-gray-500 hover:text-blue-500"
              >
                Reply
              </button>

              {/* REACTIONS */}
              {msg.reactions?.length > 0 && (
                <div className="flex gap-1 mt-2">
                  {Object.entries(
                    msg.reactions.reduce((acc, r) => {
                      const key = r.reaction || r;
                      acc[key] = (acc[key] || 0) + 1;
                      return acc;
                    }, {})
                  ).map(([emoji, count]) => (
                    <span
                      key={emoji}
                      className="px-2 text-xs text-white bg-gray-600 rounded-full cursor-pointer hover:bg-gray-700"
                    >
                      {emoji} {count}
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* TIME */}
            {isLastMessageOfGroup && (
              <div className="mt-2 ml-1 text-[10px] text-gray-600">{time}</div>
            )}
          </div>
        </div>
      )}

      {/* RIGHT (ME) */}
      {isMe && (
        <div className="max-w-xl text-right">
          <div className="relative inline-block px-3 pb-2 text-white rounded-lg shadow-md pt-7 bg-gradient-to-r from-blue-800 to-indigo-800 group">
            {/* MESSAGE ACTIONS */}
            <div className="absolute z-10 flex gap-2 transition opacity-0 top-1 right-2 group-hover:opacity-100">
              <button
                onClick={() => setActiveReactionMsg(msg.id)}
                className="px-1 text-xs bg-white rounded shadow hover:scale-110"
              >
                😊
              </button>

              {/* <button
                onClick={() =>
                  socket.emit("pin_message", {
                    messageId: msg.id,
                    groupId: selectedGroup.id,
                  })
                }
                className="px-1 text-xs bg-white rounded shadow hover:scale-110"
              >
                📌
              </button> */}
            </div>

            {/* PIN LABEL */}
            {msg.IsPinned && (
              <div className="mb-1 text-[10px] font-semibold text-yellow-300">
                📌 Pinned
              </div>
            )}

            {/* REPLY */}
            {msg.ReplyMessage && (
              <div className="p-2 mb-1 text-xs bg-gray-800 rounded">
                <span className="font-semibold text-blue-400">
                  {msg.ReplySenderName}
                </span>{" "}
                : {msg.ReplyMessage}
              </div>
            )}

            {/* MESSAGE */}
            {msg.Message && (
              <p
                className="text-sm"
                dangerouslySetInnerHTML={{
                  __html: msg.Message.replace(
                    /@(\w+)/g,
                    "<span class='text-blue-200 font-semibold'>@$1</span>"
                  ),
                }}
              />
            )}

            {/* REACTION PICKER */}
            {activeReactionMsg === msg.id && (
              <div className="flex gap-1 p-1 mt-2 bg-white border rounded shadow">
                {["❤️", "👍", "🔥", "😂", "😮"].map((emoji) => (
                  <span
                    key={emoji}
                    className="cursor-pointer hover:scale-125"
                    onClick={() => {
                      socket.emit("add_reaction", {
                        messageId: msg.id,
                        reaction: emoji,
                        groupId: selectedGroup.id,
                      });
                      setActiveReactionMsg(null);
                    }}
                  >
                    {emoji}
                  </span>
                ))}
              </div>
            )}

            {/* FILE */}
            {msg.FileUrl && (
              <div className="mt-2">
                <img
                  src={msg.FileUrl}
                  className="max-w-xs shadow rounded-xl"
                  onError={(e) => {
                    e.target.style.display = "none";
                    const videoEl = e.target.nextSibling;
                    if (videoEl) videoEl.style.display = "block";
                  }}
                />

                <video
                  src={msg.FileUrl}
                  controls
                  className="hidden max-w-xs shadow rounded-xl"
                  onError={(e) => {
                    e.target.style.display = "none";
                    const fileEl = e.target.nextSibling;
                    if (fileEl) fileEl.style.display = "block";
                  }}
                />

                <a
                  href={msg.FileUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="hidden mt-4 text-sm font-medium text-white underline"
                >
                  📎 View File
                </a>
              </div>
            )}

            {/* REPLY BUTTON */}
            <button
              onClick={() => setReplyTo(msg)}
              className="mt-1 text-[10px] text-gray-300 hover:text-blue-300"
            >
              Reply
            </button>

            {/* REACTIONS */}
            {msg.reactions?.length > 0 && (
              <div className="flex justify-end gap-1 mt-2">
                {Object.entries(
                  msg.reactions.reduce((acc, r) => {
                    const key = r.reaction || r;
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                  }, {})
                ).map(([emoji, count]) => (
                  <span
                    key={emoji}
                    className="px-2 text-xs bg-white rounded-full cursor-pointer hover:bg-gray-100"
                  >
                    {emoji} <span className="text-black">{count}</span>
                  </span>
                ))}
              </div>
            )}
          </div>

          {/* TIME + STATUS */}
          <div className="flex items-center justify-end gap-1 mt-1 text-[10px]">
            <span className="text-gray-400">{time}</span>

            <span
              className={`flex items-center justify-center w-4 h-4 rounded-full transition
                ${
                  msg.Seen
                    ? "bg-blue-600 text-white font-bold"
                    : "bg-green-600 text-white font-bold"
                }
              `}
            >
              {msg.Seen ? (
                <IoCheckmarkDone   size={10} />
              ) : (
                <IoCheckmark  size={10} />
              )}
            </span>
          </div>
        </div>
      )}
    </div>
  </div>
);
    
  })}

 
{/* ✍️ TYPING */}
{typingUsers.length > 0 && (
  <div className="flex items-center gap-2 px-4 mt-2 mb-4">

    {/* AVATARS */}
    <div className="flex -space-x-2">
      {typingUsers.slice(0, 3).map((user) => (
        user.avatar ? (
          <img
            key={user.id}
            src={user.avatar}
            className="object-cover w-6 h-6 border-2 border-white rounded-full shadow"
          />
        ) : (
          <div
            key={user.id}
            className="flex items-center justify-center w-6 h-6 text-xs font-semibold text-white bg-blue-500 border-2 border-white rounded-full"
          >
            {user.name?.charAt(0)?.toUpperCase()}
          </div>
        )
      ))}
    </div>

    {/* TEXT */}
    <div className="text-sm italic text-gray-500">
      {typingUsers.length === 1
        ? `${typingUsers[0].name} is typing...`
        : `${typingUsers.slice(0, 2).map(u => u.name).join(", ")} ${
            typingUsers.length > 2 ? "and others" : ""
          } are typing...`}
    </div>

  </div>
)}

  <div ref={messagesEndRef} />
</div>




        <div className="p-3 border-t bg-slate-700">

  {/* 🔥 FILE PREVIEW */}
  {file && (
    <div className="flex items-center gap-3 p-2 mb-2 bg-gray-100 rounded-lg">
      
      {file.type.startsWith("image/") && (
        <img
          src={URL.createObjectURL(file)}
          className="object-cover w-16 h-16 rounded-lg"
        />
      )}

      {file.type === "video/mp4" && (
        <video
          src={URL.createObjectURL(file)}
          className="w-24 rounded-lg"
          controls
        />
      )}

      <div className="flex-1 text-sm text-gray-600 truncate">
        {file.name}
      </div>

      <button
        onClick={() => setFile(null)}
        className="text-red-500"
      >
        ✕
      </button>

    </div>
  )}

  {selectedGroup && (
  <div className="flex items-end gap-2 ">

    {/* 📎 Upload */}
    <Upload
      accept="image/*,video/mp4"
      showUploadList={false}
      beforeUpload={(file) => {
        const isImage = file.type.startsWith("image/");
        const isMP4 = file.type === "video/mp4";
        const isValidExtension = /\.(jpg|jpeg|png|webp|mp4)$/i.test(file.name);

        if ((!isImage && !isMP4) || !isValidExtension) {
          message.error("Only images and MP4 videos are allowed");
          return Upload.LIST_IGNORE;
        }

        setFile(file);
        return false;
      }}
    >
      <Button
        icon={<UploadOutlined className="font-bold text-white hover:text-black"/>}
        className="flex items-center justify-center w-12 h-10 bg-black rounded-md hover:text-black"
      />
    </Upload>

    {/* 💬 Input */}
    <div className="flex-1">
      {replyTo && (
  <div className="p-2 mb-2 text-xs bg-gray-200 rounded">
    Replying to: {replyTo.Message}
    <button onClick={() => setReplyTo(null)}>✕</button>
  </div>
)}
      <Input.TextArea
        value={input}
        autoSize={{ minRows: 1, maxRows: 4 }}
          onChange={(e) => {
  const value = e.target.value;

  const formatted =
    value.charAt(0).toUpperCase() + value.slice(1);

  setInput(formatted);
  handleTyping();
}}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
          }
        }}
        placeholder="Type a message..."
        className="px-4 py-2 rounded-md resize-none"
      />
    </div>

    {/* 🚀 Send */}
    <Button
     
      icon={<SendOutlined className="text-white hover:text-blue-800"/>}
      onClick={handleSend}
      disabled={!input.trim() && !file}
      className="flex items-center justify-center w-10 h-10 bg-blue-700 rounded-md hover:bg-blue-700"
    />

  </div>
)}
</div>
      </div>
      )}

{/* ================= ADD USERS MODAL ================= */}
<Modal
  open={userModal}
  onCancel={() => setUserModal(false)}
  footer={null}
  title={
    <div className="text-lg font-semibold text-gray-800">
      Add Members
    </div>
  }
>
  {/* 🔎 SEARCH */}
  <div className="mb-4">
    <Input
      placeholder="Search by name or email..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="bg-gray-100 border-none rounded-full focus:bg-white"
    />
  </div>

  {/* 👥 USER LIST */}
  <div className="pr-1 space-y-2 overflow-y-auto max-h-64">
    {users
      .filter((u) =>
        u.FullName?.toLowerCase().includes(search.toLowerCase()) ||
        u.Email?.toLowerCase().includes(search.toLowerCase())
      )
      .map((u) => {
        const isSelected = selectedUsers.includes(u.id);

        return (
          <div
            key={u.id}
            className={`flex items-center justify-between p-2 rounded-xl cursor-pointer transition
              ${isSelected ? "bg-blue-50" : "hover:bg-gray-100"}
            `}
            onClick={() => {
              setSelectedUsers((prev) =>
                prev.includes(u.id)
                  ? prev.filter((id) => id !== u.id)
                  : [...prev, u.id]
              );
            }}
          >
            {/* LEFT */}
            <div className="flex items-center gap-3">
              {/* Avatar */}
              <div className="w-9 h-9">
                {u.ProfilePhotoUrl ? (
                  <img
                    src={u.ProfilePhotoUrl}
                    alt={u.FullName}
                    className="object-cover rounded-full shadow-sm w-9 h-9"
                  />
                ) : (
                  <div className="flex items-center justify-center font-semibold text-white rounded-full w-9 h-9 bg-gradient-to-br from-indigo-500 to-blue-600">
                    {u.FullName?.charAt(0)?.toUpperCase()}
                  </div>
                )}
              </div>

              {/* Name + Email */}
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-800">
                  {u.FullName}
                </span>

                <span className="text-xs text-gray-500">
                  {u.Email}
                </span>
              </div>
            </div>

            {/* RIGHT (Checkbox Styled) */}
            <div
              className={`w-5 h-5 flex items-center justify-center rounded-md border transition
                ${isSelected
                  ? "bg-blue-500 border-blue-500 text-white"
                  : "border-gray-300"
                }
              `}
            >
              {isSelected && "✓"}
            </div>
          </div>
        );
      })}
  </div>

  {/* ➕ ACTION BUTTON */}
  <div className="mt-4">
    <Button
      onClick={handleAddUsers}
      block
      className="h-10 font-medium text-white border-none rounded-lg bg-gradient-to-r from-blue-500 to-indigo-600 hover:opacity-90"
    >
      Add Selected Users
    </Button>
  </div>
</Modal>

     {/* ================= CREATE GROUP ================= */}
<Modal
  open={createModal}
  onOk={handleCreateGroup}
  onCancel={() => setCreateModal(false)}
  okText="Create Group"
  cancelText="Cancel"
  centered
  title={
    <div className="text-lg font-semibold text-gray-800">
      Create New Group
    </div>
  }
  okButtonProps={{
    className:
      "bg-gradient-to-r from-blue-500 to-indigo-600 border-none rounded-lg h-9 font-medium",
  }}
  cancelButtonProps={{
    className: "rounded-lg h-9",
  }}
>

  <div className="mt-2 space-y-4">

    {/* 📌 LABEL */}
    <div>
      <label className="block mb-1 text-xs font-medium text-gray-500">
        Group Name
      </label>

      {/* INPUT */}
      <Input
        value={groupName}
        onChange={(e) => setGroupName(e.target.value)}
        placeholder="Enter group name..."
        className="h-10 text-sm bg-gray-100 border-none rounded-lg focus:bg-white"
      />
    </div>

    {/* 💡 HELPER TEXT */}
    <p className="text-xs text-gray-400">
      Give your group a meaningful name so members can easily identify it.
    </p>

  </div>

</Modal>
    </div>
  );
};

export default ChatsStudent;